<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Appointments ({{ count }})</h5>
              <pager
                class="pager"
                :limit="limit"
                @onPageChanged="onPageChanged"
              ></pager>
              <div
                title="Filters"
                class="bt-filters"
                :class="{ 'bt-filter-selected': openFilters }"
                @click="openFilters = !openFilters"
              >
                <img src="../assets/ic_filter.png" alt="" />
              </div>
            </div>

            <div class="filters-container" v-if="openFilters">
              <span>Filters</span>
              <span></span>
              <span></span>
              <filter-field
                name="Title"
                type="text"
                v-model="filters.name"
                placeholder="Enter title to search"
              />

              <filter-field
                name="Status"
                type="select"
                v-model="filters.status"
                placeholder="Select a status to filter"
                :options="[
                  'pending',
                  'rider_assigned',
                  'sample_collected',
                  'completed',
                  'cancelled',
                ]"
              />

              <filter-field
                name="Mode"
                type="select"
                v-model="filters.mode"
                placeholder="Select a mode to filter"
                :options="['home_sampling', 'visit_lab']"
              />

              <filter-field
                name="Gender"
                type="select"
                v-model="filters.gender"
                placeholder="Select a gender to filter"
                :options="['male', 'female', 'other']"
              />

              <filter-field
                name="Date"
                type="date"
                v-model="filters.time"
                placeholder="Select a gender to filter"
              />

              <div class="actions">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click="search"
                >
                  Search
                </button>

                <button
                  type="button"
                  class="btn btn-outline-danger"
                  @click="clearFilters"
                  v-if="haveFilters()"
                >
                  Clear Filters
                </button>
              </div>
            </div>

            <div class="empty" v-if="appointments.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped" v-else>
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Contact</th>
                  <th scope="col">Gender</th>
                  <th scope="col">Mode</th>
                  <th scope="col">Rider</th>
                  <th scope="col">Address & Time</th>
                  <th scope="col">User/Patient</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-bind:key="appointment.id"
                  v-for="appointment in appointments"
                >
                  <th scope="row">{{ appointment.id }}</th>
                  <td>{{ appointment.name }}</td>
                  <td>
                    {{ appointment.email }} <br />
                    {{ appointment.phone }}
                  </td>
                  <td style="text-transform: capitalize">
                    {{ appointment.gender }}
                  </td>
                  <td style="text-transform: capitalize">
                    {{ appointment.mode.replaceAll("_", " ") }}
                  </td>
                  <td style="text-transform: capitalize">
                    {{
                      appointment.rider
                        ? appointment.rider.name.replaceAll("_", " ")
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{ appointment.address }}
                    <br />{{ appointment.city }}<br />{{
                      moment(appointment.time).format("YYYY/MM/DD HH:mm ")
                    }}
                  </td>
                  <td>
                    {{
                      (appointment.patient && appointment.patient.name) || "N/A"
                    }}
                  </td>
                  <td style="display: grid; gap: 10px">
                    <button
                      style="margin-left: 6px"
                      type="button"
                      class="btn btn-outline-primary"
                      @click="
                        appointmentId = appointment.id;
                        showAssignRider = true;
                      "
                    >
                      Assign Rider
                    </button>

                    <button
                      style="margin-left: 6px"
                      type="button"
                      class="btn btn-outline-primary"
                      @click="onCLickViewTests(appointment)"
                    >
                      View Tests
                    </button>

                    <button
                      style="margin-left: 6px"
                      type="button"
                      class="btn btn-outline-danger"
                      @click="onClickDeleteAppointment(appointment)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>

                <!--  -->

                <!--  -->
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <delete-item-modal
        :schemtics="appointmentDeleteSchemetics"
        v-if="showDeleteAppointmentModal"
        @success="onAppointmentDeleteSuccess"
        @cancel="onAppointmentDeleteCancelled"
      ></delete-item-modal>

      <assign-rider-component
        v-if="showAssignRider"
        :appointmentId="appointmentId"
        @success="onAssignSuccess"
        @cancel="
          showAssignRider = false;
          appointmentId = -1;
        "
      ></assign-rider-component>

      <appointment-tests-component
        v-if="showTests"
        :appointment="appointment"
        @dismiss="
          showTests = false;
          appointment = null;
        "
      ></appointment-tests-component>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
import Pager from "../components/Pager";
var NotificationsController = require("../components/NotificationsController.js");

import DeleteItemModal from "../components/DeleteItemModal.vue";
import AssignRiderComponent from "../components/AssignRiderComponent.vue";
import FilterField from "../components/FilterField.vue";
import AppointmentTestsComponent from "../components/ApointmentTestsComponent.vue";

import moment from "moment";
export default {
  name: "Appointments",
  components: {
    NavBar,
    Pager,
    AssignRiderComponent,
    DeleteItemModal,
    FilterField,
    AppointmentTestsComponent,
  },
  data() {
    return {
      keyword: "",
      resultsPerPage: 10,
      count: 0,
      page: 1,
      limit: 0,
      appointments: [],
      appointmentDeleteSchemetics: {},
      showDeleteAppointmentModal: false,
      showAssignRider: false,
      filters: {
        name: "",
        status: null,
        mode: null,
        gender: null,
        time: "",
      },
      openFilters: false,
      appointmentId: null,
      appointment: null,
      showTests: false,
    };
  },
  methods: {
    onCLickViewTests(item) {
      this.appointment = item;
      this.showTests = true;
    },
    onAssignSuccess() {
      this.showAssignRider = false;
      this.appointmentId = null;
      this.getAppointments();
    },
    clearFilters() {
      this.filters = {
        title: "",
        status: null,
        mode: null,
        gender: null,
        date: "",
      };
      this.page = 1;
      this.getAppointments();
    },
    haveFilters() {
      return !Object.values(this.filters).every((x) => x === null || x === "");
    },
    onAppointmentDeleteCancelled() {
      this.showDeleteAppointmentModal = false;
      this.appointmentDeleteSchemetics = {};
    },
    onAppointmentDeleteSuccess() {
      this.showDeleteAppointmentModal = false;
      this.appointmentDeleteSchemetics = {};
      this.getAppointments();
    },
    onClickDeleteAppointment(appointment) {
      let access_level = localStorage.getItem("access_level");
      if (access_level != 1) {
        this.$toast.error(
          "Only appointment with access level 1 can delete other appointments"
        );
        return;
      }
      let url = URLS.APPOINTMENTS.BY_ID.replace(":id", appointment.id);
      this.appointmentDeleteSchemetics = {
        endpoint: url,
        title: "Delete Appointment",
        description: `Are you sure you want to delete appointment with ID = <b> ${appointment.id} </b> ?`,
      };
      this.showDeleteAppointmentModal = true;
    },
    search() {
      if (!this.haveFilters()) {
        this.$toast.warning("Please select a filter first");
        return;
      }
      this.page = 1;
      this.getAppointments();
    },
    onPageChanged(page) {
      this.page = page;
      this.getAppointments();
    },
    getAppointments() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.APPOINTMENTS.LIST;
      url = url + "?limit=" + this.resultsPerPage;
      url = url + "&page=" + this.page;

      let where = {};
      if (this.haveFilters()) {
        Object.keys(this.filters).forEach((e) => {
          console.log(e);
          let val = this.filters[e];
          if (val !== null && val !== "") {
            where[e] = val;
          }
        });
      }
      console.log("where");
      console.log(where);
      HTTP.get(url, {
        params: { where: where },
      })
        .then((response) => {
          let data = response.data;
          let rows = data.rows;
          ctx.count = data.count;
          let limit = Math.ceil(data.count / ctx.resultsPerPage);
          ctx.limit = limit;
          ctx.previousEnable = limit > 0;
          ctx.nextEnable = ctx.page < limit;
          ctx.appointments = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getAppointments();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    .bt-filters {
      height: 3rem;
      width: 3rem;
      display: flex;
      border: 0.1rem solid rgb(250, 165, 6);
      border-radius: 4px;
      transition: all 0.2s ease-in-out;

      img {
        width: 40%;
        margin: auto;
        filter: invert(78%) sepia(51%) saturate(4655%) hue-rotate(357deg)
          brightness(104%) contrast(99%);
        transition: all 0.2s ease-in-out;
      }

      &:hover {
        background: orange;
        img {
          filter: invert(100%) sepia(0%) saturate(7480%) hue-rotate(143deg)
            brightness(104%) contrast(104%);
        }
      }
    }

    .bt-filter-selected {
      background: orange;
      border-radius: 50%;
      img {
        filter: invert(100%) sepia(0%) saturate(7480%) hue-rotate(143deg)
          brightness(104%) contrast(104%);
      }
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  // button{
  //   margin-left: 10px;
  // }
  span {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .actions {
    display: -ms-inline-grid;
    width: 100%;

    gap: 0.5rem;
    button {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
